import { yupResolver } from '@hookform/resolvers/yup';
import { IValidTransactionInquiryFilterFormMeta } from '@Modules/admin/archiving/containers/mixedHandlers/archivedTables/validTransactionInquiry/ValidTransactionInquiryFilterFormMeta';
import { CustomButton } from '@Modules/core/components';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import { getFormFieldsName } from '@Shared/utils/getFormFieldsNames';
import React from 'react';
import { useForm } from 'react-hook-form';

type Props = {
  meta: IValidTransactionInquiryFilterFormMeta,
} & Omit<TFormUIProps, "isLoading" | "isSubmitting">;

export default React.forwardRef(function ValidTransactionInquiryForm(
  { onSubmit, meta }: Props,
  ref: any
) {
  const submitBtnRef = React.useRef<HTMLButtonElement>(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IValidTransactionInquiryFilterFormMeta>({
    resolver: yupResolver(meta.schema),
  });

  React.useImperativeHandle(ref, () => ({
    submitBtnRef,
  }));

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)} ref={ref} mb={6}>
      <CC.SimpleGrid columns={{ base: 1, md: 2 }} gridRowGap={4} columnGap={16} my={4}>
        {displayCustomInputs<IValidTransactionInquiryFilterFormMeta>(
          meta,
          register,
          errors,
          false, [meta.acquiringBank.name, meta.emitterBank.name]
        )}
      </CC.SimpleGrid>

      <CC.Box>
        {displayCustomInputs<IValidTransactionInquiryFilterFormMeta>(
          meta,
          register,
          errors,
          false, [meta.transactionCode.name]
        )}
      </CC.Box>

      <CC.SimpleGrid columns={{ base: 1, md: 2 }} gridRowGap={4} columnGap={16} my={4}>
        {displayCustomInputs<IValidTransactionInquiryFilterFormMeta>(
          meta,
          register,
          errors,
          false, getFormFieldsName(meta).slice(3)
        )}
      </CC.SimpleGrid>
      
      <CC.Center>
        <CustomButton type={'submit'} w={"70%"}>
          Filtrer
        </CustomButton>
      </CC.Center>
    </CC.Box>
  );
});
